import React, { useState } from 'react';
import { Box, Button, Form, FormField, Layer } from 'grommet';
import { Edit } from 'grommet-icons';
import PropTypes from 'prop-types';
import { SearchSelect } from '../../components/SearchSelect';
import { Utils } from '../../helpers/Utils';
import CandidacyService from '../../api/candidacy-service';

export const EditCandidacyModalButton = ({
    candidacy,
    candidacyStatusEnums = [],
    onSaved,
}) => {
    const [show, setShow] = React.useState(false);

    return (
        <Box>
            <Button
                size="small"
                primary
                label={<Edit size="small" color="white" />}
                onClick={() => setShow(true)}
            />
            {show && (
                <EditCandidacyModal
                    candidacy={candidacy}
                    candidacyStatusEnums={candidacyStatusEnums}
                    setShow={setShow}
                    onSaved={onSaved}
                />
            )}
        </Box>
    );
};

const EditCandidacyModal = ({
    candidacy,
    candidacyStatusEnums = [],
    setShow,
    onSaved,
}) => {
    const [isButtonBusy, setIsButtonBusy] = useState(false);

    const [value, setValue] = useState({
        id: candidacy.id,
        status: candidacy.status,
    });

    const candidacyStatusEnumOptions = candidacyStatusEnums.map((x) => ({
        ...x,
        label: Utils.convertEnumStringToLabel(x.name),
    }));

    const handleSubmit = async () => {
        setIsButtonBusy(true);

        try {
            await new CandidacyService().updateCandidacy(value);
            setShow(false);
            if (onSaved) {
                onSaved();
            } else {
                window.location.reload();
            }
        } catch (error) {
            console.error('Error updating candidacy: ', { error });
        }

        setIsButtonBusy(false);
    };

    return (
        <Layer
            onEsc={() => setShow(false)}
            onClickOutside={() => setShow(false)}>
            <Box pad="large">
                <Form
                    value={value}
                    onChange={(nextValue) => setValue(nextValue)}
                    onSubmit={({ value }) => {
                        handleSubmit(value);
                    }}>
                    <FormField label="Candidacy Status" name="status" required>
                        <SearchSelect
                            name="status"
                            labelKey="label"
                            valueKey="name"
                            defaultValue={value.status}
                            options={candidacyStatusEnumOptions}
                            placeholder="Select Candidacy Status"
                            updateFormData={(val) =>
                                setValue({ ...value, status: val.name })
                            }
                        />
                    </FormField>
                    <Box direction="row" gap="medium">
                        <Button
                            type="submit"
                            primary
                            label="Submit"
                            busy={isButtonBusy}
                        />
                    </Box>
                </Form>
            </Box>
        </Layer>
    );
};

const candidacyShape = PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    status: PropTypes.string.isRequired,
});

EditCandidacyModalButton.propTypes = {
    candidacy: candidacyShape.isRequired,
    candidacyStatusEnums: PropTypes.array,
    onSaved: PropTypes.func,
};

EditCandidacyModal.propTypes = {
    candidacy: candidacyShape.isRequired,
    candidacyStatusEnums: PropTypes.array,
    setShow: PropTypes.func,
    onSaved: PropTypes.func,
};
